import { render, staticRenderFns } from "./TiposCambioDivisa.vue?vue&type=template&id=eb83cca8&"
import script from "./TiposCambioDivisa.vue?vue&type=script&lang=js&"
export * from "./TiposCambioDivisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports